<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Manage News</h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <n-button
                                @click.native="openModal()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>

                        </div>
                        
                        <fg-input>
                            <el-input type="search"  class="mb-3" style="width: 400px"
                            prefix-icon="el-icon-search"
                            :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                            v-model="searchQuery"
                            aria-controls="datatables"
                            ></el-input>
                        </fg-input>
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        
                        <el-table-column :min-width="150" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <el-tooltip class="item" effect="dark" content="Approve News" placement="top">
                                <n-button
                                    @click.native="handleApprove(props.$index, props.row)"
                                    class="approve"
                                    type="success"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-check"></i>
                                </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="View News" placement="top">
                                <n-button
                                    @click.native="handleView(props.$index, props.row)"
                                    class="view"
                                    type="primary"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-eye"></i>
                                </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Edit News" placement="top">
                                <n-button
                                    @click.native="handleEdit(props.$index, props.row)"
                                    class="edit"
                                    type="warning"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-pencil"></i>
                                </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Delete News" placement="top">
                                <n-button
                                    @click.native="handleDelete(props.$index, props.row)"
                                    class="remove"
                                    type="danger"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-times"></i>
                                </n-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

        <modal :show.sync="modals.add" headerClasses="justify-content-center" footerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Add New News</h4>
            <form>
                <div class="row">
                    <div class="col-12">
                        <fg-input
                            type="text"
                            required
                            name="title"
                            label="News Title"
                            v-validate="modelValidations.title"
                            :error="getError('title')"
                            v-model="model.title">
                        </fg-input>
                    </div>
                    
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="featured_news"
                            label="Featured News ?"
                            v-validate="modelValidations.featured_news"
                            :error="getError('featured_news')"
                            v-model="model.featured_news">
                            <n-switch v-model="model.featured_news" on-text="Yes" off-text="No"></n-switch>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="draft"
                            label="Draft News ?"
                            v-validate="modelValidations.draft"
                            :error="getError('draft')"
                            v-model="model.draft">
                            <n-switch v-model="model.draft" on-text="Yes" off-text="No"></n-switch>
                        </fg-input>
                    </div>
                    <div class="col-12">
                        <fg-input
                            type="text"
                            name="small_description"
                            label="Small Description"
                            v-validate="modelValidations.small_description"
                            :error="getError('small_description')"
                            v-model="model.small_description">
                            <ckeditor :editor="editor" v-model="model.small_description" :config="editorConfig"></ckeditor>
                        </fg-input>
                    </div>
                    <div class="col-12">
                        <fg-input
                            type="text"
                            name="long_description"
                            label="Long Description"
                            v-validate="modelValidations.long_description"
                            :error="getError('long_description')"
                            v-model="model.long_description">
                            <ckeditor :editor="editor" v-model="model.long_description" :config="editorConfig"></ckeditor>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            name="input"
                            label="Tags"
                            v-validate="modelValidations.input"
                            :error="getError('input')"
                            v-model="model.input">
                            <el-tag :key="index" v-for="(val, index) in model.tags" size="small" type="primary" :closable="true" :close-transition="false" @close="handleClose(val)">{{ val }}</el-tag>
                            <input type="text" placeholder="Add new tag" class="form-control input-new-tag" v-model="model.input" ref="saveTagInput" size="mini" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="author"
                            label="Author"
                            v-validate="modelValidations.author"
                            :error="getError('author')"
                            v-model="model.author">
                            <el-select class="select-primary" placeholder="Select Author" v-model="model.author" value-key="register_no" clearable filterable>
                                <el-option v-for="(option, index) in authors" class="select-primary" :value="option" :label="`${option.register_no} - ${option.name}`" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-12">
                        <label>Cover Image</label>
                        <el-upload
                            class="avatar-uploader"
                            name="image"
                            accept="image/jpeg,image/png"
                            :data="{path: 'glimpses/news/'}"
                            :action="uploadURL"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <!-- <img v-if="model.image" :src="model.image" class="avatar"> -->
                            <div v-if="model.image" class="avatar" :style="`background-image: url(${model.image})`"></div>
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                    
                </div>
            </form>
            <template slot="footer">
                <n-button @click.native.prevent="validate()" type="primary">Save News</n-button>
            </template>
        </modal>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Transfer, Tag, Upload } from "element-ui";
import { Pagination as NPagination, Modal, Switch } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Transfer.name]: Transfer,
        [Tag.name]: Tag,
        Modal,
        [Switch.name]: Switch,
        [Upload.name]: Upload,
    },
    computed: {
        ...mapGetters({
            tableData: 'getNews',
            teachers: 'getTeachers',
            students: 'getStudents',
            preferences: 'getPreferences',
            authTokens: 'getAuthTokens',
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        },
        authors() {
            return (this.$currentUser.roles.includes('admin') ? this.students.concat(this.teachers) : this.$currentUser) 
        },
        headers(){
            this.authTokens['content-type'] = 'multipart/form-data'
            let {token, refreshtoken} = this.authTokens
            return {token, refreshtoken};
        },
        uploadURL(){
            return `${process.env.VUE_APP_BASE_URL}/glimpses/upload`
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "title", "author" ],
            tableColumns: [
                {
                    prop: "slug",
                    label: "Slug",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "title",
                    label: "Title",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "author",
                    label: "Author",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return `${cellValue.register_no} - ${cellValue.name}`
                    }
                },
                {
                    prop: "tags",
                    label: "Tags",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return cellValue.join(', ').trim(', ')
                    }
                },
                {
                    prop: "featured_news",
                    label: "Featured?",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return cellValue ? 'Yes' : 'No'
                    }
                },
                {
                    prop: "draft",
                    label: "Draft?",
                    minWidth: 120,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return cellValue ? 'Yes' : 'No'
                    }
                },
                {
                    prop: "date",
                    label: "Date",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        let d = new Date(cellValue)
                        return d.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' })
                    }
                },
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false
            },
            model: {
                title: '',
                date: null,
                featured_news: false,
                draft: true,
                author: '',
                tags: [],
                image: '',
                small_description: '<p>Content of the editor small.</p>',
                long_description: '<p>Content of the editor long.</p>',
                input: '',
                
            },
            editor: ClassicEditor,
            editorConfig: {
                // The configuration of the editor.
            },
            modelValidations: {
                title: {
                    required: true,
                },
                author: {
                    required: true,
                },
                small_description: {
                    required: true,
                },
                long_description: {
                    required: true,
                },
            },
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    },
    methods: {
        handleApprove(index, row) {
            this.$store.dispatch('approveNews', row)
        },
        handleView(index, row) {
            this.$router.push(`/glimpses/news/view/${row.slug}`)
        },
        handleEdit(index, row) {
            this.$router.push(`/glimpses/news/edit/${row.slug}`)
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        deleteRow(row) {
            this.$store.dispatch('deleteNews', row.slug)
        },
        openModal(){
            this.$router.push('/glimpses/news/compose')
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            this.$validator.validateAll().then(isValid => {
                // this.$emit('on-submit', this.registerForm, isValid);
                if(isValid){
                    
                    switch(this.scope){
                        case 'add'  : this.$store.dispatch('createNews', this.model); break;
                        case 'edit' : this.$store.dispatch('updateNews', this.model); break;
                    }
                    
                    this.modals.add = false
                }
            });
        },
        handleClose (val) {
            this.model.tags.splice(this.model.tags.indexOf(val), 1)
        },
        handleInputConfirm () {
            let inputValue = this.model.input
            if (inputValue) {
                this.model.tags.push(inputValue)
            }
            this.model.input = ''
        },
        handlePreview(file) {
            this.model.image = URL.createObjectURL(file.raw);
        },
        handleAvatarSuccess(res, file) {
            this.model.image = res.data.image;
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$notify({
                message: `Cover picture size can not exceed 2MB!`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            })
            }
            return isLt2M;
        }
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getNews');

        if(this.$currentUser.roles.includes('admin')){
            this.$store.dispatch('getStudents');
            this.$store.dispatch('getTeachers');
        }
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .bootstrap-switch{
    display: block;
    width: 90px!important;
    height: 35px!important;

    &.bootstrap-switch-on{
        .bootstrap-switch-label{
            left: 70%;
        }
    }

    .bootstrap-switch-label{
        width: 35px!important;
        height: 35px!important;
    }

    .bootstrap-switch-handle-off,
    .bootstrap-switch-handle-on{
        font-weight: bold;
        line-height: 22px;
        text-indent: 10px;
        color: #273c75!important;
        width: 100%!important;
    }
    .bootstrap-switch-handle-off{
        text-indent: 15px;
    }
}
</style>

